import { Route, Routes } from 'react-router-dom';
import { Error500 } from './components/Error500';
import { Error404 } from './components/Error404';
import { ErrorsLayout } from './ErrorsLayout';

const ErrorsPage = () => (
  <Routes>
    <Route element={<ErrorsLayout />}>
      <Route element={<Error404 />} path="404" />
      <Route element={<Error500 />} path="500" />
      <Route index element={<Error404 />} />
    </Route>
  </Routes>
);

export { ErrorsPage };
